import React from 'react';
import { connect } from 'react-redux'
import WeeklyTotalWin from '../views/WeeklyTotalWin'
import { 
  listUnionInfo, 
  fetchLatestUnionData,
  fetchPeriodData,
  fetchChartData,
  fetchMultiPeriodData,
  fetchMultiChartData,
  searchEntity,
  loadDataByHierarchy,
  SEARCH_ENTITY,
  clearMultiPeriodData,
  fetchPeriodPlayerData,
  fetchMultiPeriodPlayerData,
  resetWeeklyTotalWinData
} from '../action/userAction'

function mapStateToProps(state, ownProps) {
  return {
    weekly_total_win: state.getIn(['data', 'weekly_total_win']),
    weekly_total_win_sum: state.getIn(['data', 'weekly_total_win_sum']),
    weekly_total_player_win: state.getIn(['data', 'weekly_total_player_win']),
    weekly_total_player_count: state.getIn(['data', 'weekly_total_player_count']),
    weekly_total_player_sum: state.getIn(['data', 'weekly_total_player_sum']),
    error: state.getIn(['data', 'weekly_total_win_error']),
    union_info: state.getIn(['data', 'union_info']),
    
    periods: state.getIn(['data', 'weekly_total_win_periods']),
    currentPeriodIndex: state.getIn(['data', 'weekly_total_win_currentPeriodIndex']),
    multi_periods: state.getIn(['data', 'weekly_total_win_multi_periods']),
    multi_period_range: state.getIn(['data', 'weekly_total_win_multi_range']),
    clubData: state.getIn(['data', 'weekly_total_win_clubData']),
    agentData: state.getIn(['data', 'weekly_total_win_agentData']),
    subagentData: state.getIn(['data', 'weekly_total_win_subagentData']),
    chartData: state.getIn(['data', 'weekly_total_win_chartData']),
    
    loading: state.getIn(['data', 'fetch_status', 'status']) === 'loading',
    isMultiPeriod: state.getIn(['data', 'weekly_total_win_isMultiPeriod']),
    periodRange: state.getIn(['data', 'weekly_total_win_periodRange']),
    _triggerLoadData: state.getIn(['data', 'weekly_total_win_triggerLoadData']),
    _hierarchyPath: state.getIn(['data', 'weekly_total_win_hierarchyPath']),
    periodSelectionMode: state.getIn(['data', 'weekly_total_win_periodSelectionMode']),
    searchResults: state.getIn(['data', 'weekly_total_win_searchResults']),
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: () => {
    dispatch(fetchLatestUnionData());
    dispatch(listUnionInfo());
    dispatch(fetchPeriodPlayerData(0, { hierarchyLevel: 'union', unionId: 0 }));
  },
  
  loadPeriodData: (periodIndex, hierarchyPath) => {
    dispatch(fetchPeriodData(periodIndex, hierarchyPath));
  },

  loadPeriodPlayerData: (periodIndex, hierarchyPath, sort_by = "fee", sort_order = -1, page = 1, page_size = 50) => {
    dispatch(fetchPeriodPlayerData(periodIndex, hierarchyPath, sort_by, sort_order, page, page_size));
  },

  loadMultiPeriodPlayerData: (periodRange, hierarchyPath, sort_by = "fee", sort_order = -1, page = 1, page_size = 50) => {
    dispatch(fetchMultiPeriodPlayerData(periodRange[0], periodRange[1], hierarchyPath, sort_by, sort_order, page, page_size));
  },
  
  loadMultiPeriodData: (periodRange, hierarchyPath) => {
    dispatch(fetchMultiPeriodData(periodRange, hierarchyPath));
  },
  
  loadChartData: (timeRange, hierarchyPath) => {
    dispatch(fetchChartData(timeRange, hierarchyPath));
  },

  loadMultiChartData: (timeRange, hierarchyPath) => {
    dispatch(fetchMultiChartData(timeRange, hierarchyPath));
  },

  onSearchEntity: (level, query) => {
    dispatch(searchEntity(level, query));
  },

  loadDataByHierarchy: (hierarchyPath, periodSelectionMode, periodRange, currentPeriodIndex) => {
    dispatch(loadDataByHierarchy(hierarchyPath, periodSelectionMode, periodRange, currentPeriodIndex));
  },
  
  clearMultiPeriodData: () => {
    dispatch(clearMultiPeriodData());
  },
  
  resetWeeklyTotalWinData: () => {
    dispatch(resetWeeklyTotalWinData());
  },
});

// Create a higher-order component to handle the middleware logic
const withDataLoading = (WrappedComponent) => {
  return class extends React.Component {
    componentDidUpdate(prevProps) {
      // Check if we need to trigger data loading after search
      if (this.props._triggerLoadData && 
          this.props._triggerLoadData !== prevProps._triggerLoadData) {
        this.props.loadDataByHierarchy(
          this.props._hierarchyPath,
          this.props.periodSelectionMode,
          this.props.periodRange,
          this.props.currentPeriodIndex
        );
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

// Connect the component with the HOC
const WeeklyTotalWinWithDataLoading = withDataLoading(WeeklyTotalWin);

const WeeklyTotalWinContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeeklyTotalWinWithDataLoading);

export default WeeklyTotalWinContainer;